import { cn } from "@/lib/utils";

interface SpinnerProps {
  className?: string;
}

export const Spinner = (props: SpinnerProps) => {
  return (
    <div
      data-testid="spinner"
      className={cn(
        "inline-block h-5 w-5 border-t-current border-r-current animate-[spin_0.7s_linear_infinite] rounded-full border-2 border-b-transparent border-l-transparent",
        props?.className,
      )}
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
};
